import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const domains = [
  { icon: 'ri-code-s-slash-line', label: 'Développement logiciel' },
  { icon: 'ri-global-line', label: 'Création de sites web' },
  { icon: 'ri-settings-3-line', label: 'Solutions informatiques sur mesure' },
];

export default function About() {
  return (
    <div className="font-sans">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-40 pb-20 bg-navy-900 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/61d54abec10e9467c48e344c51d61814.jpg"
              alt=""
              className="w-full h-full object-cover object-top opacity-20"
            />
          </div>
          <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
            <p className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4">À propos</p>
            <h1 className="font-heading font-bold text-white text-4xl md:text-5xl leading-tight mb-6">
              À propos de CICHORZ
            </h1>
            <div className="w-16 h-1 bg-white/30 mx-auto rounded-full"></div>
          </div>
        </section>

        {/* Main content */}
        <section className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              {/* Left: image + info */}
              <div>
                <div className="rounded-2xl overflow-hidden mb-8 border-4 border-navy-900/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=professional%20male%20software%20developer%20programmer%20working%20laptop%20Paris%20office%20modern%20minimalist%20clean%20workspace%20technology&width=600&height=750&seq=about-portrait-cichorz-04&orientation=portrait"
                    alt="Mariusz Slawomir Cichorz – Développeur informatique Paris"
                    className="w-full h-80 object-cover object-top"
                  />
                </div>
                <div className="bg-gray-50 rounded-xl p-6 space-y-3">
                  <h3 className="font-heading font-semibold text-navy-900 text-lg mb-4">Informations entreprise</h3>
                  <div className="grid grid-cols-1 gap-3">
                    {[
                      { label: 'Dirigeant', value: 'Mariusz Slawomir Cichorz' },
                      { label: 'Statut', value: 'Entrepreneur individuel' },
                      { label: 'SIRET', value: '102 737 178 00016' },
                      { label: 'Activité', value: '62.01Z – Programmation informatique' },
                      { label: 'Localisation', value: 'Paris 15e, France' },
                    ].map((item) => (
                      <div key={item.label} className="flex flex-col">
                        <span className="text-xs uppercase tracking-wider text-gray-400 font-medium">{item.label}</span>
                        <span className="text-navy-900 text-sm font-medium mt-0.5">{item.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right: text */}
              <div>
                <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Notre histoire</p>
                <h2 className="font-heading font-bold text-navy-900 text-3xl md:text-4xl leading-tight mb-6">
                  Une expertise technique<br />au service de vos projets
                </h2>
                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  <strong className="text-navy-900">CICHORZ</strong> est une activité indépendante spécialisée dans la <strong className="text-navy-900">programmation informatique</strong>, basée à Paris. L'entreprise est dirigée par <strong className="text-navy-900">Mariusz Slawomir Cichorz</strong>, développeur proposant des solutions techniques adaptées aux besoins des entreprises et particuliers.
                </p>
                <p className="text-gray-600 text-base leading-relaxed mb-10">
                  L'objectif est de fournir des solutions <strong className="text-navy-900">fiables</strong>, <strong className="text-navy-900">modernes</strong> et <strong className="text-navy-900">adaptées</strong> à chaque projet, en alliant rigueur technique et compréhension des enjeux métier.
                </p>

                {/* Domains */}
                <div className="mb-10">
                  <h3 className="font-heading font-semibold text-navy-900 text-lg mb-5">Domaines d'intervention</h3>
                  <ul className="space-y-4">
                    {domains.map((d) => (
                      <li key={d.label} className="flex items-center gap-4">
                        <div className="w-10 h-10 flex items-center justify-center bg-navy-900/5 rounded-lg flex-shrink-0">
                          <i className={`${d.icon} text-xl text-navy-900`}></i>
                        </div>
                        <span className="text-gray-700 font-medium">{d.label}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Quote */}
                <blockquote className="border-l-4 border-navy-900 pl-6 bg-gray-50 py-4 pr-4 rounded-r-lg">
                  <p className="text-gray-600 italic text-base leading-relaxed">
                    "Chaque projet est réalisé avec rigueur afin de proposer des solutions efficaces, sécurisées et évolutives."
                  </p>
                </blockquote>

                <div className="mt-10">
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 bg-navy-900 text-white font-semibold px-7 py-3.5 rounded-lg hover:bg-navy-800 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Discuter de votre projet
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
